import React, { useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';

import Europe from '../components/Europe.js';

import { participatingCountries, codeToCountry, countryToCode } from '../utils/data';
import '../utils/polyfills';

import css from './Map.module.css';

export const MapComponent = ({ data, getColor, getCategory, zoom = 0, getTooltipContent }) => {
	const mapRef = useRef(null);
	const [currentCountry, setCurrentCountry] = useState(null);
	const [tooltip, setTooltip] = useState();

	const countriesWithData = useMemo(() => data.map((d) => countryToCode[d.id]), [data]);

	const countryColors = useMemo(() => {
		let colors = '';
		for (let i = 0; i < participatingCountries.length; i++) {
			const country = participatingCountries[i];
			const countryData = data.find((d) => d.id === country);
			const color = getColor(countryData ? countryData.value : null);
			colors += `#${countryToCode[country]} { fill: ${color};} `;
		}
		return colors;
	}, [data]);

	useEffect(() => {
		const svg = mapRef.current;
		if (!svg) {
			return;
		}
		const onHover = (e) => {
			const countryEl = e.target.closest(`.${css.country}`);
			if (countryEl && countriesWithData.includes(countryEl.id)) {
				const id = countryEl.id;
				const name = codeToCountry[id];
				const countryData = data.find((c) => c.id == name);
				setTooltip({
					id,
					name,
					touch: e.type.includes('touch'),
					category: getCategory(countryData.value),
					color: getColor(countryData.value),
					left: e.layerX,
					top: e.layerY,
				});
			} else {
				setTooltip(false);
			}
		};
		const onLeave = () => setTooltip(false);
		svg.addEventListener('mousemove', onHover);
		svg.addEventListener('touchmove', onHover);
		svg.addEventListener('touchstart', onHover);
		svg.addEventListener('mouseleave', onLeave);
		svg.addEventListener('touchend', onLeave);
		return () => {
			svg.removeEventListener('mousemove', onHover);
			svg.removeEventListener('touchstart', onHover);
			svg.removeEventListener('touchmove', onHover);
			svg.removeEventListener('mouseleave', onLeave);
			svg.removeEventListener('touchend', onLeave);
		};
	}, [data, countriesWithData, mapRef]);

	return (
		<div className={css.root}>
			{tooltip && <Tooltip {...tooltip} />}
			<style type="text/css">{countryColors}</style>
			<Europe
				countriesWithData={countriesWithData}
				forwadedRef={mapRef}
				hoveredCountry={tooltip ? tooltip.id : ''}
				hoveredCountryColor={tooltip ? tooltip.color : null}
				countryClassName={css.country}
			/>
		</div>
	);
};

const Tooltip = ({ name, category, left, top, touch }) => {
	return (
		<div className={classnames(css.tooltip, { [css.touch]: touch })} style={{ left, top }}>
			<strong>{name}</strong>
			<div>{category}</div>
		</div>
	);
};
export default MapComponent;
